import { getOfferPackageName, getPackageNumberOfNights } from '../PackageSetupStep/utils';

// svc-offer won't content-approve a package with no nights, and Salesforce allows the field to be empty or 0.
export function getPackageNamesMissingNights(packages: Array<App.Package>): Array<string> {
  return packages.filter((pkg) => !getPackageNumberOfNights(pkg)).map(getOfferPackageName);
}
